import React from 'react'
import { Link } from 'react-router-dom'

const KeyBenifits = () => {
    return (
        <div>
            <section className="features__area mr-t-b-60" style={{ padding: "50px 0 90px" }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6">
                            <div className="section__title white-title text-center mb-50">
                                <span className="sub-title">Key Benefits</span>
                                <h2 className="title">Key Benefits For Your Success</h2>
                                <p>
                                    Enjoy interactive lessons, expert mentorship, and flexible learning
                                    that accelerates your career growth.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="features__item">
                                <div className="features__icon">
                                    <img
                                        src="/assets/img/icons/features_icon01.svg"
                                        className="injectable"
                                        alt="img"
                                    />
                                </div>
                                <div className="features__content">
                                    <h4 className="title">Task Learning</h4>
                                    <p>Learn through real tasks and projects.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="features__item">
                                <div className="features__icon">
                                    <img
                                        src="/assets/img/icons/features_icon02.svg"
                                        className="injectable"
                                        alt="img"
                                    />
                                </div>
                                <div className="features__content">
                                    <h4 className="title">Mock Interview</h4>
                                    <p>Practice real interviews with expert feedback.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="features__item">
                                <div className="features__icon">
                                    <img
                                        src="/assets/img/icons/features_icon03.svg"
                                        className="injectable"
                                        alt="img"
                                    />
                                </div>
                                <div className="features__content">
                                    <h4 className="title">Top Mentors</h4>
                                    <p>Learn from mentors working in top companies.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="features__item">
                                <div className="features__icon">
                                    <img
                                        src="/assets/img/icons/features_icon04.svg"
                                        className="injectable"
                                        alt="img"
                                    />
                                </div>
                                <div className="features__content">
                                    <h4 className="title">Diverse Courses</h4>
                                    <p>Choose from many programsin any field.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="instructor__area-two">
                <div className="container">
                    <div className="instructor__item-wrap-two">
                        <div className="row">
                            <div className="col-xl-6">
                                <div className="instructor__item-two tg-svg">
                                    <div className="instructor__thumb-two">
                                        <img src="/images/become-mentor-new.png" alt="img" />
                                        <div className="shape-one">
                                            <img
                                                src="/assets/img/instructor/instructor_shape01.svg"
                                                alt="img"
                                                className="injectable"
                                            />
                                        </div>
                                        <div className="shape-two">
                                            <span
                                                className="svg-icon"
                                                id="instructor-svg"
                                                data-svg-icon="/assets/img/instructor/instructor_shape02.svg"
                                            />
                                        </div>
                                    </div>
                                    <div className="instructor__content-two">
                                        <h3 className="title">
                                            <Link to="/mentor-register">Become a Mentor</Link>
                                        </h3>
                                        <p>
                                            Share your expertise, mentor aspiring students, and shape future
                                            corporate leaders.
                                        </p>
                                        <div className="tg-button-wrap">
                                            <Link to="/mentor-register" className="btn arrow-btn">
                                                Apply Now{" "}
                                                <img
                                                    src="/assets/img/icons/right_arrow.svg"
                                                    alt="img"
                                                    className="injectable"
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="instructor__item-two tg-svg">
                                    <div className="instructor__thumb-two">
                                        <img src="/images/ambassdor-img.png" alt="img" />
                                        <div className="shape-one">
                                            <img
                                                src="/assets/img/instructor/instructor_shape01.svg"
                                                alt="img"
                                                className="injectable"
                                            />
                                        </div>
                                        <div className="shape-two">
                                            <span
                                                className="svg-icon"
                                                id="instructor-svg-two"
                                                data-svg-icon="/assets/img/instructor/instructor_shape02.svg"
                                            />
                                        </div>
                                    </div>
                                    <div className="instructor__content-two">
                                        <h3 className="title">
                                            <a href="/programs">Join as a Learner</a>
                                        </h3>
                                        <p>
                                            Gain hands-on training, real-world experience, and practical
                                            skills to fuel your career growth.
                                        </p>
                                        <div className="tg-button-wrap">
                                            <a href="/programs" className="btn arrow-btn">
                                                Apply Now{" "}
                                                <img
                                                    src="/assets/img/icons/right_arrow.svg"
                                                    alt="img"
                                                    className="injectable"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
         </div>
    )
}

export default KeyBenifits
